// @flow

import React, { Component } from 'react'
import styled from 'styled-components'
// $FlowFixMe
import Lightbox from 'react-images'
import { media } from 'src/theme/style-utils'
import type { Gallery as GalleryType } from 'src/types'

const StyledGalleryButton = styled.button`
  position: relative;
  top: -60px;
  left: 0;
  font-size: 13px;
  width: 150px;
  height: 40px;
  border-radius: 60px;
  background-color: #ffffff;
  border: solid 1px #d2d9e2;
  font-family: 'TheCollectiveBecome', 'RelativeFaux', 'Helvetica', 'Arial', sans-serif;
  color: #000000;

  ${media.desktop`
    left: 0;
  `};
`

const GalleryWrapper = styled.div`
  max-width: 1200px;
  margin: auto;
  padding: 0 20px;
  ${media.tabletLarge`
    justify-content: space-between;
    padding: 0 80px;
  `}
`
type State = {
  lightboxIsOpen: boolean,
  currentImage: number
}

type Props = {
  images: Array<GalleryType>
}

export default class ImageGallery extends Component<Props, State> {
  state = {
    lightboxIsOpen: false,
    currentImage: 0
  }

  openLightbox = (index: number, event: Object) => {
    event.preventDefault()
    this.setState({
      currentImage: index,
      lightboxIsOpen: true
    })
  }

  gotoNext = () => {
    this.setState({
      currentImage: this.state.currentImage + 1
    })
  }

  gotoPrevious = () => {
    this.setState({
      currentImage: this.state.currentImage - 1
    })
  }

  closeLightbox = () => {
    this.setState({
      currentImage: 0,
      lightboxIsOpen: false
    })
  }

  gotoImage = (index: number) => {
    this.setState({
      currentImage: index
    })
  }

  handleClickImage = () => {
    if (this.state.currentImage === this.props.images.length - 1) return

    this.gotoNext()
  }

  render() {
    const { lightboxIsOpen } = this.state
    const { images } = this.props

    return (
      <GalleryWrapper>
        <StyledGalleryButton type="button" onClick={() => this.setState({ lightboxIsOpen: true })}>
          View Gallery
        </StyledGalleryButton>

        {lightboxIsOpen && (
          <Lightbox
            currentImage={this.state.currentImage}
            images={images}
            isOpen={lightboxIsOpen}
            onClickImage={this.handleClickImage}
            onClickNext={this.gotoNext}
            onClickPrev={this.gotoPrevious}
            onClickThumbnail={this.gotoImage}
            onClose={this.closeLightbox}
            showThumbnails={true}
          />
        )}
      </GalleryWrapper>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/ImageGallery/index.js